export enum DialogTypeEnum {
  searchResult = 'searchResult',
  unBind = 'unBind',
  unBindTips = 'unBindTips',
  bindTips = 'bindTips',
  refuse = 'refuse',
  bind = 'bind',
  dissolve = 'dissolve',
  modifyPassword='modifyPassword'
}
